import React, { FC, useMemo } from 'react'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '../../context/GiveawayContext'
import { GiveawayLogo } from '../Hero/GiveawayLogo'
import { FooterNavigation } from './FooterNavigation'
import { GiveawayRulesSection } from './GiveawayRulesSection'

const hiddenTabsOnInActive = new Set(['GiveawayDetailsTab', 'GiveawayPrizesTab'])

export const GiveawayFooter: FC = () => {
  const { t } = useTranslate('tickets')
  const { push } = useSafeRouter()
  const { scrollToTab, scrollToProducts, content, isActive, theatricalSlug } = useGiveawayContext()
  const tabs = content.tabsCollection?.items

  const siteNavigation = useMemo(() => {
    if (!tabs) return []
    const tabNavigation = tabs
      .map((tab) => ({
        name: tab?.title || '',
        onClick: () => scrollToTab(tab?.__typename),
        type: tab?.__typename,
      }))
      .filter((tab) => {
        if (isActive) return true
        return !hiddenTabsOnInActive.has(tab?.type || '')
      })

    const ctaLink = {
      name: isActive ? t('preOrderTickets', 'Pre-Order Tickets') : t('getShowtimes', 'Get Showtimes'),
      onClick: () => (isActive ? scrollToProducts() : push(`/tickets/${theatricalSlug}`)),
    }
    return [ctaLink, ...(tabNavigation || [])]
  }, [isActive, push, scrollToProducts, scrollToTab, t, tabs, theatricalSlug])

  return (
    <footer className="relative bg-giveaway-primary px-4 pb-[120px] pt-[72px] md:px-[88px] md:py-[72px]">
      <div className="relative inset-0 z-20 mx-auto flex h-full w-full max-w-[1440px] flex-col items-start gap-10 lg:flex-row lg:justify-between xl:gap-[120px]">
        <GiveawayLogo isFooter />
        <GiveawayRulesSection className="gap-2 md:hidden md:gap-3" />
        <FooterNavigation siteNavigation={siteNavigation} />
        <GiveawayRulesSection className="hidden gap-2 md:flex md:gap-3" />
      </div>
    </footer>
  )
}
